import React from 'react';
import { useSelector } from 'react-redux';
import { AgCharts } from 'ag-charts-react';
import 'ag-charts-enterprise';

const NumberTransChart = () => {
    const { hourlySales } = useSelector(state => state.reports || {});

    console.log(hourlySales)

    const renderer = (params) => {
        return (
            `<div class="ag-chart-tooltip-custom"><b class="title">${params.datum.time}:00</b><br/><b> Number of Transaction: ${params.datum.numSales}</b><br/><b>Previous Day: ${params.datum.prevSales}</b></div>`
        );
    };

    const chartOptions = {
        data: hourlySales,
        series: [
            {
                type: "bar",
                xKey: "time",
                yKey: "numSales",
                yName: "Count",
                interpolation: { type: "smooth" },
                tooltip: { renderer },
                fill:   '#4ABA6C',
                barWidth: 10,
            }
        ],
        axes: [
          {
            type: 'time',  // X-axis is a category axis for the date
            position: 'bottom',
            label: {
                formatter: ({ value }) => `${(value % 24).toString()}:00`,
            },
            gridLine: {
                enabled: true,
            },
            interval: {
                step: 1,
                maxSpacing: 13,
            },
          },
          {
            type: 'number',
            position: 'left',
            keys: ["numSales"],
            gridLine: {
                enabled: true,
            },
            title: {
                text: `Count`,
            },
          },
        ],
        background: {
            fill: '#f8f9fa', // Set background color here
        },
    };
    return(
        <React.Fragment>
            <h3 className="m-0 text-center text-justify mt-2">Number of Transactions</h3>
            <div style={{ height: 450 }}>
                <AgCharts options={chartOptions} style={{ height: 450 }}/>
            </div>
        </React.Fragment>
    )
};
export default NumberTransChart;